import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { CaseDetailComponent } from './detail/case-detail.component';
import { CaseFinalStepComponent } from "./crud/case-final-step/case-final-step.component";
import { CaseListComponent } from './list/case-list.component';
import { ConfirmCaseStepComponent } from "./crud/confirm-step/confirm-case-step.component";
import { CrudCaseComponent } from './crud/crud-case.component';
import { CrudCaseFileComponent } from "../casefiles/crud/crud-casefile.component";
import { HomeComponent } from '../../../app/home/home.component';
import { CaseFilesManagerComponent } from "../case-files-manager/case-files-manager.component";
import { FileCorrectionComponent } from "./file-correction/file-correction/file-correction.component";

const routes: Routes = [
  {
    path: '',
    component: CaseListComponent,
  },
  {
    path: 'nuevo-caso',
    component: CrudCaseComponent,
    children: [
      {
        path: 'paciente',
        loadChildren: () => import('../patients/patient.module').then(m => m.PatientModule)
      },
      {
        path: 'prescripcion/:id',
        loadChildren: () => import('../prescriptions/prescription.module').then(m => m.PrescriptionModule)
      },
      {
        path: 'registros-dentales/:id',
        component: CrudCaseFileComponent
      },
      {
        path: 'confirmacion-caso',
        component: ConfirmCaseStepComponent
      },
      {
        path: 'pago',
        component: CaseFinalStepComponent
      }
    ]
  },
  {
    path: 'detail/:id',
    component: CaseDetailComponent
  },
  {
    path: 'archivos-de-caso/:id/stage/:stageNumber',
    component: CaseFilesManagerComponent
  },
  {
    path: 'file-correction/:id',
    component: FileCorrectionComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CaseRoutingModule { }

